import { useMemo } from 'react';
import { useConfirmApi } from 'utils/api/ApiHooks';

export interface MetadataItem {
  id: string;
  name: string;
  description?: string;
  internal_tool_name?: string;
}

export interface SkillMetadataItem extends MetadataItem {
  required_resources: string[];
  instructions: string;
}

export interface TemplateMetadata {
  id: string;
  name: string;
  description: string;
  purpose: string;
  responsibilities: string;
  guidelines: string;
  resources: MetadataItem[];
  skills: SkillMetadataItem[];
}

export interface PromptMetadataItem {
  id: string;
  text: string;
  category: string;
  required_capabilities: string[];
}

interface AgentMetadataResponse {
  templates: TemplateMetadata[];
  prompts: PromptMetadataItem[];
  resources: MetadataItem[];
}

export const useAgentMetadata = () => {
  const { data, status } = useConfirmApi<AgentMetadataResponse>({
    url: 'agents/metadata',
    method: 'GET',
  });

  return useMemo(() => {
    const templates = data?.templates ?? [];
    const prompts = data?.prompts ?? [];
    const resources = data?.resources ?? [];

    return {
      templates,
      prompts,
      resources,
      isLoading: status === 'LOADING',
    };
  }, [data, status]);
};
